import { observable, action, computed } from 'mobx';

import { onWarriorBonusesChanged } from '../lib/dbCalls';
import { WarriorBonusesType } from '../lib/types';
import { isQuestCondition } from '../utils/questUtils';

class Bonuses {
  @observable
  bonuses: WarriorBonusesType = [];

  bonusesChangedRef: any = null;

  listenChanges(warriorId: string) {
    this.bonusesChangedRef = onWarriorBonusesChanged(warriorId, this.onBonusesChanged);
  }

  @action
  onBonusesChanged = (snapshot: any) => {
    const val = snapshot.val();
    this.bonuses = Array.isArray(val) ? val : [];
  };

  // Classic bonus chests only — quest rewards share this store but are counted
  // separately so each surface badges just its own claimable rewards.
  @computed
  get unsettledCount(): number {
    return this.bonuses.filter((b) => !b.settled && !isQuestCondition(b.condition)).length;
  }

  @computed
  get claimableQuestCount(): number {
    return this.bonuses.filter((b) => !b.settled && isQuestCondition(b.condition)).length;
  }

  clear() {
    if (this.bonusesChangedRef) {
      this.bonusesChangedRef.off('value', this.onBonusesChanged);
      this.bonusesChangedRef = null;
    }
    this.bonuses = [];
  }
}

export default new Bonuses();
